import styled from 'styled-components';
import { caption, spacing, textColors } from 'ui/theme';
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { DateFormat, localizeDateTime } from 'utils/l10n';
import { useListId, useTranslation } from '../../hooks';
import { useListDetailsContext } from '../../contexts/listDetails';

export const ListDetailsContainer = styled.ul`
  ${caption}
  color: ${textColors.textSecondary};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.half};
  line-height: 1.15em;
  margin-bottom: 0;
  padding: 0;

  li {
    &:last-child::before {
      content: '•';
      padding-right: ${spacing.half};
    }
  }
`;

export const testIds = {
  listDetailsContainer: 'list-details-container',
};

export const ListDetails = () => {
  const { t } = useTranslation();
  const { list, isLoading } = useListDetailsContext();
  const listId = useListId(); // backup from url params if useListDetailsContext fails

  // wait for list details from context to be ready,
  // otherwise localizeDateTime receives a non-valid date and crashes
  if (isLoading) return null;

  return (
    <ListDetailsContainer data-test={testIds.listDetailsContainer}>
      <Badge variant={BADGE_VARIANTS.INFO}>{list?.emailListType || <>&nbsp;</>}</Badge>
      <li>{`ID: ${list?.id || listId}`}</li>
      {list?.createdAt && (
        <li>
          {t('header.listCreatedAt', {
            createdAt: localizeDateTime(new Date(list.createdAt), { dateStyle: DateFormat.Short }),
          })}
        </li>
      )}
    </ListDetailsContainer>
  );
};
